<script lang="ts">
  // In-world Settings overlay, opened from the overworld menu so the player stays on the map. The
  // actual settings rows live in SettingsPanel (shared with the Free Duel route); this is just the
  // modal chrome: backdrop, window, close. World-only rows show because session.mode is "world".
  import { fade, scale } from "svelte/transition";
  import { expoOut } from "svelte/easing";
  import DataWindow from "./ui/DataWindow.svelte";
  import SettingsPanel from "./SettingsPanel.svelte";
  import { onEscape } from "../hotkeys.ts";
  import { draggableDialog } from "../actions/draggableDialog.ts";

  let { onClose }: { onClose: () => void } = $props();

  onEscape(() => onClose());
</script>

<div class="mobile-dialog-host fixed inset-0 z-50 grid place-items-center" role="presentation">
  <button class="modal-scrim absolute inset-0 bg-void/50" transition:fade={{ duration: 160 }} onclick={onClose} aria-label="Close settings"></button>

  <div
    class="mobile-full-dialog relative w-[min(440px,92vw)]"
    role="dialog"
    aria-modal="true"
    aria-label="Settings"
    use:draggableDialog
    transition:scale={{ start: 0.96, opacity: 0, duration: 220, easing: expoOut }}
  >
    <DataWindow c={18} fill class="mobile-dialog-panel">
      <div data-dialog-drag-handle class="dialog-drag-handle flex items-center justify-between border-b border-cyan-dim/40 bg-surface-2/70 px-5 py-2.5">
        <span class="font-display text-[0.72rem] font-semibold uppercase tracking-[0.26em] text-cyan">Settings</span>
        <button onclick={onClose} class="text-ink-dim transition-colors hover:text-cyan" aria-label="Close">
          <svg viewBox="0 0 24 24" class="size-4" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
        </button>
      </div>

      <div class="mobile-dialog-scroll max-h-[70dvh] overflow-y-auto scroll-cyber">
        <SettingsPanel />
      </div>
    </DataWindow>
  </div>
</div>
